import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsTeaser() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/news`)
      .then((r) => setItems(r.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section
      data-testid="news-teaser"
      className="relative py-24 md:py-36 px-6 md:px-12 max-w-[1440px] mx-auto"
    >
      <div className="flex items-end justify-between gap-6 mb-12">
        <div>
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/50">
            <span className="h-px w-8 bg-[#C48F56]" />
            Insights & News
          </div>
          <h2 className="mt-5 font-display text-5xl md:text-6xl tracking-tightest">
            Osservatorio <span className="text-[#C48F56]">urbano.</span>
          </h2>
        </div>
        <Link
          to="/news"
          data-testid="news-view-all"
          className="hidden md:inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2 text-sm hover:bg-white hover:text-black transition-colors"
        >
          Tutti gli articoli <ArrowUpRight size={14} />
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {items.map((n) => (
          <Link
            key={n.slug}
            to={`/news/${n.slug}`}
            data-testid={`news-card-${n.slug}`}
            className="group rounded-2xl overflow-hidden border border-white/10 bg-[#0F0F14] hover:border-white/20 transition-colors"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-[1.2s] group-hover:scale-110"
                style={{ backgroundImage: `url(${n.cover})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <div className="absolute top-4 left-4 glass rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.2em]">
                {n.category}
              </div>
            </div>
            <div className="p-6">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                {new Date(n.date).toLocaleDateString("it-IT", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}{" "}
                · {n.read_time}
              </div>
              <h3 className="mt-3 font-display text-2xl tracking-tight leading-tight">
                {n.title}
              </h3>
              <p className="mt-3 text-white/60 text-sm leading-relaxed line-clamp-2">
                {n.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
